import styled from "styled-components";

export const Demos = styled.div`
 .teste {
        padding: 10px 0 20px 0px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0,0,0,0.25);
    }
    h2{
        font-size: 24px;
        font-weight: 500;
        color: #87868F;
        margin: 25px 0 0 100px;
    }

    h4{
        margin-bottom: 10px;
        color: #403F4C;
        margin-top: 20px; 
    }

    .teacher {
      margin-top: 0px;
    }

    .planInfo{
        margin: 0 0 0 100px;
        h3{
            font-size: 20px;
            font-weight: 500;
            color: #004FFF;
            margin: 32px 0 15px 0;
        }

        /** Form **/
        .formulario{
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 15px 0 0 0;
            width: 100%;


          .input-demoClassSchedules{
            span{
              font-size: 14px !important;
            }
          }

          .inputs{
            display: flex;
            gap: 20px;

            p{
                font-size: 11px;
                color: #87868F;
                margin-top: 22px;
            }
          }

            label{
                color: #403F4C;
                font-size: 14px;
                font-weight: 500;

                /* &:before{
                    display: none;
                } */
            }

            span{
                color: #87868F;
                font-size: 10px;
                margin-left: 5px;
            }

            input{
                width: 600px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
                margin-bottom: 15px;
            }

            .switch__container{
                margin: 5px auto;
                span{
                    margin-left: 50px;
                }
                span.bestSeller{
                    margin-left: 46%;
                }
            }

            .switch--shadow:checked + label:before {
                background-color: #8ce196;
            }

            .numberClass{
                margin: 10px 0 0 20px;
                input{
                    width: 200px;
                }
            }
        }

        .telefone{
          flex-direction: row;
          display: flex;
          align-items: center;
          gap: 12px;

          .inputMobile{
            width: 290px !important;
          }

          .addInput{
            width: 155px !important;
            height: 32px;
            border-radius: 26px;
            margin-left: 20px;
            background: transparent;
            border: 1px solid rgb(64, 63, 76);
            color: rgb(64, 63, 76);
            font-family: "Work Sans", sans-serif;
            font-size: 14px;
            cursor: pointer;
            padding: 0 12px;
            font-weight: 500;
          }

          .delete{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: none;
            color: rgb(255, 86, 102);
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0px 20px 7px;
          }
        }

          select{
            width: 290px;
            height: 34px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin-bottom: 15px;
          }


          .rowSelects{
            display: flex;
            align-items: center;
            gap: 20px;

            .classToolId, input{
                width: 290px !important;
              }


            .classToolIdInput{
              display: flex;
              flex-direction: column;
            }
          }


          .rowSelectsCountry{
            display: flex;
            align-items: center;
            gap: 20px;

            select:first-child{
              width: 200px;
            }

            input.jsx-4179805763  {
                width: 390px !important;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
                padding-left: 10px;
            }
            button.jsx-4179805763 {
              margin: 0 0 1px 0 !important;
              width: 100% !important;
              border: 0 !important;
            }
          }

          .lineSchedule{

            input{
              font-family: "Quicksand", sans-serif !important;
            }

            display: flex;
            width: 100% !important;
            gap: 12px;
            align-items: center;

            span{
              margin: 0 !important;
            }

            input{
              width: 150px !important;
            }

            select{
              width: 162px !important;
            }

            .inputNameAffiliate{
              width: 400px !important;
            }

            .studentTimezone{
              width: 150px !important;
            }

            .input-scheduledEnd{
              display: flex;
              flex-direction: column;
            }
          }

          .schedule_tmz{
              display: flex;
              width: 100%;
              justify-content: flex-start;
              border-top: 1px solid #ccc;
              padding-top: 10px;
              gap: 12px;

              p{
                width: 150px;
                padding-left: 10px;
              }

              p:last-child{
                padding-left: 0 !important;
              }

              span{
                font-size: 12px;
                margin: 0 !important;
              }
            }

            .teacher-rating {
              h4 {
                color: #403F4C;
                font-size: 16px;
                display: inline-block;
                margin: 12px 10px -10px 0;
              }

              p {
                display: inline-block;
                color: #403F4C;
                font-size: 28px;
                margin-right: 8px;
              }

              span {
                bottom: 3px;
                margin: 0 3px 0 0;
                font-size: 18px;
                color: #FDC35E
              }
            }

          .languageInput{
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding: 0 12px;
          }



          .teacherFlex{
            display: flex;
          }


          .teacherFlexSelects{
            display: flex;
            gap: 12px;
            margin-top: 16px;
          }

          .lineClassConverted{
            display: flex;
            gap: 16px;

            input{
              width: 300px !important;
            }
          }

          .studentTimezone{
            font-size: 14px;
            color: rgba(64,63,76,.6);

            span{
              font-size: inherit;
              font-weight: 600;
            }
          }

          .avatar{
              img{
                width: 72px;
                height: 72px;
                border-radius: 50%;
                margin-right: 20px;
              }
            }


            .delete{
                width: 83px;
                height: 22px;
                border-radius: 26px;
                background: transparent;
                border: none;
                color: rgb(255, 86, 102);
                cursor: pointer;
                font-size: 11px;
                font-weight: bold;
                margin: 0 !important;
              }

            .input-status {
            .select-wrapper {
              position: relative;

              &:before {
                content: "";
                position: absolute;
                z-index: 3;
                top: 9px;
                right: 20px;
                width: 8px;
                height: 8px;
                border-right: 1.5px solid #fff;
                border-bottom: 1.5px solid #fff;
                transform: rotate(45deg);
                pointer-events: none;

              }

              select {
                background-color: #004FFF !important;
                padding: 5px 40px 5px 15px !important;
                border: none !important;
                background-image: none !important;
                border-radius: 26px !important;
                font-size: 18px !important;
                font-weight: 500 !important;
                font-family: 'Work Sans',sans-serif !important;
                color: #fff !important;
                margin: 0 !important;

                &[data-item="PENDING"] {
                  background-color: #fdc35e !important;
                }

                &[data-item="DONE"] {
                  background-color: #0ED572 !important;
                }

                &[data-item="CANCELLED"], &[data-item="CANCELED"],&[data-item="NOSHOW"]  {
                  background-color: #FF5666 !important;
                }

                &[data-item="CANCELLEDOUTOFLIMIT"]  {
                  background-color: #ffa500 !important;
                }

                option {
                  background-color: #fff !important;
                  color: initial;
                  font-size: 14px !important;
                }
              }
            }
          }


        .deleteType{
            border: 1px solid #FF5666 !important;
            border-radius: 26px;
            color: #FF5666;
            font-size: 12px;
            font-weight: 500;
            background-color: transparent;
            width: auto !important;
            height: 22px;
            cursor: pointer;
            margin: 0 0 10px 0;

            &:last-child{
                width: 103px;
                margin-top: 20px;
            }

            span{
                color: #FF5666;
                margin-top: 2px !important;
            }
        }

        .deletePlans{
            width: 103px !important;
            height: 22px !important;
            border-radius: 26px;
            background: transparent;
            border: 1px solid #FF5666 !important;
            color: #FF5666 !important;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 0;
            font-family: 'Quicksand', sans-serif;
        }

        .lingos{
            h4{
                color: #004FFF;
                font-size: 20px;
                font-weight: 500;
                margin: 30px 0 15px 0;
            }

            .lingoSelects{
                display: flex;
            }

            .linha{
                width: 2px;
                background-color: #707070;
                height: auto;
                opacity: 0.2;
                margin-left: 12px;
            }

            .lineContent{
                display: flex;
            }

            .linhaPrice{
                width: 2px;
                background-color: #707070;
                height: auto;
                opacity: 0.2;
                margin: 0 16px 0 0;
            }

            .selects{
                display: flex;
                flex-direction: column;
                margin-left: 13px;

                .input-lingo {
                    width: 210px;
                    height: 32px;
                    margin: 0;
                }

                .delet{
                    display: flex;
                    flex-direction: column;

                    .inputDelete{
                        display: flex;
                        flex-direction: column;
                    }

                    .delete{
                        color: red;
                        margin: 10px 0 0 10px;
                        font-size: 12px;
                        font-weight: 500;
                        border: none;
                        text-align: left;
                    }

                    .input-lingo{
                        margin-bottom: 10px;
                    }

                }

                button{
                    width: 107px;
                    height: 32px;
                    background-color: transparent;
                    border: 1px solid #787780;
                    border-radius: 26px;
                    font-weight: 500;
                    color: #787780;
                    cursor: pointer;
                    font-family: 'Work Sans', sans-serif;
                    font-size: 14px;

                    .fa{
                       font-size: 15px;
                       margin-left: 5px;
                    }
                }

                .priceSelect{
                    display: flex;
                    flex-direction: column;
                }

                select, input{
                    width: 200px;
                }
            }

             .price{

                .lingoSelects{
                    span{
                        text-align: center;
                        font-size: 12px;
                        margin-top: 5px;
                    }

                    .countryCurrency{
                        display: flex;
                        flex-direction: column;
                    }

                    span.currency{
                        text-align: left;
                        margin-left: 20px;
                        margin-top: 0;
                    }
                    label{
                        font-weight: 500;
                        font-size: 14px;
                        color: #403F4C;
                        font-family: 'Quicksand', sans-serif;
                    }

                    button{
                        margin: 10px 0 35px 18px;
                        width: 126px;
                    }

                    .delete {
                        margin-top: 0;
                        margin-bottom: 30px;
                        text-align: left;
                    }

                }

            }

        }

        .delete {
            margin: 12px 0 0 0;
        }

    }

    .buttons{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            cursor: pointer;

            button{
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-weight: bold;
                font-size: 14px;
                border-radius: 26px;
                padding: 10px 20px;
                height: 38px;
                margin-top: 5px;
                cursor: pointer;
                font-family: 'Quicksand', sans-serif;

                &:first-child{
                    background-color: transparent;
                    border:1px solid #787780;
                    color: #787780;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    width: 71px;
                    height: 28px;
                    margin-top: 8px;
                    margin-right: 10px;
                    cursor: pointer;
                    font-family: 'Quicksand',sans-serif;
                    align-items: center;
                    display: flex;
                    justify-content: center;

                    .fa{
                        margin-right: 8px;
                        font-size: 20px;
                    }
                }

            }
    }

`;

export const TableUser = styled.div`
    margin-top: 21px;

    .boxTable{
        display: flex;
        width: 100%;
        padding: 0 12px 0 10px;
        background-color: #fff;
        justify-content: space-between;
        border: 1px solid;
        flex-direction: row;

        .boxItem{
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            h3{
                font-size: 12px;
                color: #403F4C;
                font-weight: bold;
            }

            .itemTop{
                h3{
                    margin: 11px 139px 0 0;
                }
            }

        }
        hr{
            margin-top: 0;
        }
    }


    table{
        width: 100%;
        border-collapse: collapse;
        margin: 15px 0 15px 0;

        tr{
            text-align: left;
            height: 35px;

            th{
                color: #403F4C;
                font-size: 12px;
                font-weight: bold;

                /* &:first-child{
                    width: 55%;
                } */
            }

            :nth-child(2){
                border-top: 1px solid #B2B2B7;
            }
        }

        td {
            border-bottom: 1px solid #B2B2B7;
            height: 33px;
            font-size: 14px;
            color: #403F4C;
            font-weight: 500;
            font-family: 'Work Sans', sans-serif;

            span{
                color: #0ED572;
                font-weight: bold;
            }
            .inativo{
                color: #FF5666;
                font-weight: bold;
            }
            button{
                background-color: transparent;
                border: 1px solid #787780;
                border-radius: 26px;
                color: #787780;
                font-size: 11px;
                width: 58px;
                height: 22px;
                float: right;
                cursor: pointer;
                padding-left: 8px;

                .fa{
                    margin-right: 3px;
                }
            }
        }
    }

`;
